var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLamp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.422 15.582A6.528 6.528 0 0 1 5.434 9.56c0-4.077 3.721-7.277 7.943-6.422 2.5.512 4.521 2.522 5.043 5.022.678 3.266-1.1 6.276-3.833 7.431l-.003 1.288a1.501 1.501 0 0 1-1.5 1.498H10.92c-.83 0-1.503-.675-1.501-1.505l.004-1.291Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10.71 21h2.576M14.587 15.592H12.14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLamp);
export default __webpack_public_path__ + "static/media/lamp.39240ff56e5390d2d56d5425c123a5e4.svg";
export { ForwardRef as ReactComponent };